import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useCurrentCareRegion } from '~/hooks/useCurrentCareRegion';
import { setLocationId } from '../../../../../../../../../actions/newBooking';
import { symptomsSubmit } from '../../../../../../../../../actions/symptoms';
import { analyticsTrackEvent } from '../../../../../../../../../core/analytics';
import {
  DRAWER_TYPE_TELEMED,
  PROFILE_DISCOVER_CARD_TAPPED,
} from '../../../../../../../../../core/analytics/events';
import history, { SolvHistory } from '../../../../../../../../../core/history';
import { createLocationUrlFromLocation } from '../../../../../../../../../core/url/location';
import { isTelemedLocation } from '../../../../../../../../../core/util/location';
import useToggleRuntimeModal from '../../../../../../../../../hooks/runtime/useToggleRuntimeModal';
import { URGENT_CARE_VALUE } from '../../../../../../../../Home/Tiles/ProviderTypes';
import { CategoryIds } from '../../../../../../SwimLanes/util/tileEnums';

export const covidNavTile = 'covidNavTile';

/**
 * Callback for clicking on Book Video Visit Tile.
 *
 * The logic is as follows:
 *
 * IF clinicRelationship is telemed
 *  - goto CDP(clinicRelationship)
 *
 * ELSE IF clinicRelationship has associatedTelemedLocationId
 *  - goto CDP(clinicRelationship.associatedTelemedLocationId)
 *
 * ELSE
 *  - IF in state which has telemed options
 *   - SRP(telemed locations)
 *  - ELSE
 *   - show "Coming Soon" modal
 *
 * @param userProfileId
 * @param clinicRelationship
 *
 * @returns A callback to start a video visit process
 */
function useBookVideoVisit(userProfileId: string, clinicRelationship: any, showSolvPlus = false) {
  const dispatch = useDispatch();

  const currentRegionStateCode = useCurrentCareRegion(userProfileId);

  return useCallback(() => {
    let videoVisitRoute;
    let categoryId;
    const historyState: SolvHistory = {
      covidNavTile: true,
      isAccountVideoVisitTileClicked: true,
    };

    if (isTelemedLocation(clinicRelationship) && !showSolvPlus) {
      videoVisitRoute = createLocationUrlFromLocation(clinicRelationship);
    } else if (clinicRelationship?.associatedTelemedLocationId && !showSolvPlus) {
      // TODO: fix video visit highlight in cdp
      dispatch(setLocationId(clinicRelationship.associatedTelemedLocationId));
      videoVisitRoute = createLocationUrlFromLocation(clinicRelationship);
      categoryId = CategoryIds.FAVORITES;
    } else {
      dispatch(
        symptomsSubmit({
          providerType: URGENT_CARE_VALUE,
          reasonForVisit: 'telemed visit',
          requestedServices: [],
          isServiceHardFilter: false,
          isCovidTestRelatedSearch: false,
          isTelemed: currentRegionStateCode,
          highlight: 'Video Visit',
        })
      );

      videoVisitRoute = `/search?isTelemed=${currentRegionStateCode}`;
      categoryId = CategoryIds.GET_STARTED;
    }

    analyticsTrackEvent(PROFILE_DISCOVER_CARD_TAPPED, {
      categoryId,
      drawerType: DRAWER_TYPE_TELEMED,
    });

    videoVisitRoute && history.push(videoVisitRoute, historyState);
  }, [clinicRelationship, dispatch, showSolvPlus, currentRegionStateCode]);
}

export default useBookVideoVisit;
